// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1tsU1","buttons":"styles_buttons__2yhy0"};